import { message } from 'antd';
import { FileType, SearchType, ShareType, TabKeyType } from '../types';
import { getHeader, uniqBy } from '../utils';
import Fetch from './request';

export interface GroupsParamesType {
  gid: string;
  permission_type: number | string;
}
export interface OrgsParamesType {
  code: string;
  permission_type: number | string;
}
export interface UserParamesType {
  id: string;
  permission_type: number | string;
}
export interface AddMembersParamesType {
  id: string;
  type: FileType;
  dialogueMessage?: ShareType;
  toGroups: GroupsParamesType[];
  toOrgs: OrgsParamesType[];
  toUsers: UserParamesType[];
  toEpssUsers: any;
}

export interface AllSharesMembersType {
  length: number;
  start: number;
  memberType?: number;
  page_id?: string;
  search?: string;
  type?: number;
}

export const addShareUser = (parames: AddMembersParamesType) => {
  return Fetch<any>({
    url: 'v1/shares',
    api: 'joyspace.share.create',
    method: 'POST',
    body: {
      page_id: parames.id,
      type: parames.type,
      to_groups: parames.toGroups,
      to_orgs: parames.toOrgs,
      to_eepaas_users: parames.toEpssUsers,
      to_users: parames.toUsers,
      dialogueMessage: parames.dialogueMessage || ShareType.ShareAI,
      dialogueContent: '',
    },
  })
    .then((res: any) => {
      const [data, err, result] = res;
      if (err) {
        if (!err['errResolved']) {
          message.error(err.msg);
        }
        return false;
      }
      return true;
    })
    .catch(() => false);
};

export const getShareUserNum = (pageId = '') => {
  return Fetch<any>({
    url: `v1/shares/${pageId}/allSharesCount`,
    api: 'joyspace.share.allsharesCount',
    method: 'GET',
  })
    .then((res: any) => {
      const [data, err, result] = res;
      if (err) {
        if (!err['errResolved']) {
          message.error(err.msg);
        }
        return 0;
      }
      return result.data;
    })
    .catch(() => 0);
};

export const getAllSharesMembers = (parames: AllSharesMembersType) => {
  return Fetch<any>({
    url: 'v1/shares/allSharesMembers',
    api: 'joyspace.share.allSharesMembers',
    method: 'POST',
    body: parames,
  });
};

export const getSharesPermissionType = (shareId: string) => {
  return Fetch<any>({
    url: `v1/shares/${shareId}/permissionType`,
    api: 'joyspace.share.permissionType',
    method: 'GET',
  });
};

export const transferOwner = (
  pageId = '',
  myPermission: number | undefined,
  newOwnerTenantId: string,
  newOwnerId: string
) => {
  return Fetch<any>({
    url: `v1/apply/transferPermission`,
    api: 'joyspace.apply.transferPermission',
    method: 'POST',
    body: {
      pageId,
      reservePermission: myPermission,
      toTenantId: newOwnerTenantId,
      toUserId: newOwnerId,
    },
  })
    .then((res: any) => {
      const [data, err, result] = res;
      if (err) {
        if (!err['errResolved']) {
          message.error(err.msg);
        }
        return 0;
      }
      return result.data;
    })
    .catch(() => false);
};

export const getUser = () => {
  return Fetch<any>({
    api: 'joyspace.user.info',
    method: 'GET',
  })
    .then((res: any) => {
      const [data, err, result] = res;
      if (err) {
        if (!err['errResolved']) {
          message.error(err.msg);
        }
        return null;
      }
      return result.data;
    })
    .catch(() => false);
};
